import React, { useState } from "react";
import { useAuth } from "../../config/AuthContext";
import { makeStyles } from "@material-ui/core/styles";
import { Typography, IconButton } from "@material-ui/core";
import FavoriteBorderTwoToneIcon from "@material-ui/icons/FavoriteBorderTwoTone";
import FavoriteIcon from "@material-ui/icons/Favorite";

const useStyles = makeStyles((theme) => ({
  appreciatePostContainer: {
    // padding: theme.spacing(1, 1),
    width: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },

  appreciateDiv: {
    padding: theme.spacing(1),
    borderRadius: "5px",
    background: "transparent",
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    "& .MuiTypography-root": {
      color: theme.palette.text.secondary,
    },
    // "& .MuiIconButton-root": {
    //   color: theme.palette.text.secondary,
    // },
  },
}));

const AppreciatePost = ({ blogKey }) => {
  const { dbRef, increment } = useAuth();
  const classes = useStyles();
  const [appreciate, setAppreciate] = useState(false);

  const handleAppreciation = () => {
    setAppreciate(true);

    dbRef.child(`blogs/${blogKey}`).update({
      BlogAppreciate: increment,
    });
  };

  return (
    <div className={classes.appreciatePostContainer}>
      {!appreciate ? (
        <div className={classes.appreciateDiv}>
          <Typography>Loved this post? Press</Typography>
          <IconButton
            aria-label="appreciate-post"
            size="medium"
            onClick={handleAppreciation}
            color="secondary"
          >
            <FavoriteBorderTwoToneIcon />
          </IconButton>
        </div>
      ) : (
        <div className={classes.appreciateDiv}>
          <Typography>Thanks for appreciating.</Typography>
          <IconButton
            aria-label="appreciate-post"
            size="medium"
            color="secondary"
          >
            <FavoriteIcon />
          </IconButton>
        </div>
      )}
    </div>
  );
};

export default AppreciatePost;
